import React from "react";

import { CsvFile } from "icons";

import { Tag } from "clearsense-ui/components";
import { LinkText } from "components/Common/TableStyle";

export const COLUMN_DATA = [
  {
    dataIndex: "filename",
    key: "filename",
    title: "File name",
    render: (_, { link, filename }) => <LinkText link={link} text={filename} />,
    sorter: (a, b) => a.filename.localeCompare(b.filename),
  },
  {
    dataIndex: "rowCount",
    key: "rowCount",
    title: "Row count",
    align: "center",
    width: 150,
    sorter: (a, b) => a.rowCount - b.rowCount,
  },
  {
    dataIndex: "columnCount",
    key: "columnCount",
    title: "Column count",
    align: "center",
    width: 180,
    sorter: (a, b) => a.columnCount - b.columnCount,
  },
  {
    dataIndex: "source",
    key: "source",
    title: "Source",
    align: "center",
    width: 165,
    render: (_, { isLocal }) => (
      <Tag
        label={isLocal ? "Local" : "Remote"}
        color={isLocal ? "#E8F4FD" : "#EBF4EC"}
        icon={CsvFile}
      />
    ),
    sorter: ({ isLocal }) => (isLocal ? -1 : 1),
  },
];
